import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class SubscriptionManager implements OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor() {}

  public call<T>(
    observable: Observable<T>|undefined,
    success?: (result: T) => void,
    error?: (err: any) => void
  ): void {
    if (!observable) {
      return;
    }
    const sub = observable.subscribe({
      next: (result) => {
        if (success) {
          success(result);
        }
      },
      error: (err) => {
        if (error) {
          error(err);
        }
      }
    });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
  }
}
